"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InventoryForecastPageActions;
(function (InventoryForecastPageActions) {
    InventoryForecastPageActions["Loaded"] = "Loaded";
    InventoryForecastPageActions["Loading"] = "Loading";
    InventoryForecastPageActions["ErrorMessageChanged"] = "ErrorMessageChanged";
})(InventoryForecastPageActions || (InventoryForecastPageActions = {}));
exports.default = InventoryForecastPageActions;
